import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/cfg/app.config';
 
function setVh() {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
}

function debounce(fn: () => void, wait = 120) {
  let timer: number | undefined;
  return () => {
    if (timer) {
      window.clearTimeout(timer);
    }
    timer = window.setTimeout(fn, wait);
  };
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  setVh();

  const onResize = debounce(setVh, 120);
  window.addEventListener('resize', onResize, { passive: true });

  window.addEventListener('beforeunload', () => {
    window.removeEventListener('resize', onResize);
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
